var _rect, _rect2, _rect3, _rect4, _g, _rect5, _rect6, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 200,
    viewBox: "0 0 294 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 200,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 52.2578,
    width: 150.213,
    height: 95.4844,
    rx: 7.02024,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.9531,
    y: 66.707,
    width: 96.8522,
    height: 12.1065,
    rx: 6.05326,
    fill: "#A3BBD1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4805,
    y: 94.1777,
    width: 125.76,
    height: 12.8089,
    rx: 6.40444,
    fill: "#A3BBD1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1215_28531)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.516,
    y: 52.2578,
    width: 95.4844,
    height: 95.4844,
    rx: 6.98667,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.352,
    y: 130.719,
    width: 126.289,
    height: 5.06034,
    rx: 2.53017,
    transform: "rotate(-45 173.352 130.719)",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.812,
    y: 111.143,
    width: 17.5171,
    height: 19.0545,
    rx: 3.49333,
    transform: "rotate(-45 206.812 111.143)",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.938,
    y: 124.276,
    width: 69.0254,
    height: 19.0545,
    rx: 3.49333,
    transform: "rotate(-45 145.938 124.276)",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.648,
    y: 64.5649,
    width: 59.3795,
    height: 19.0545,
    rx: 3.49333,
    transform: "rotate(-45 205.648 64.5649)",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.676,
    y: 126.281,
    width: 17.5171,
    height: 19.0545,
    rx: 3.49333,
    transform: "rotate(-45 191.676 126.281)",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.938,
    y: 89.0186,
    width: 17.5171,
    height: 65.9328,
    rx: 3.49333,
    transform: "rotate(-45 228.938 89.0186)",
    fill: "#A3BBD1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.113,
    y: 127.445,
    width: 17.5171,
    height: 50.0987,
    rx: 3.49333,
    transform: "rotate(-45 223.113 127.445)",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.617 92.4361C223.605 91.448 225.207 91.448 226.195 92.4361L279.133 145.376C280.121 146.364 280.121 147.966 279.133 148.954C278.144 149.942 276.542 149.942 275.554 148.954L222.617 96.0143C221.629 95.0262 221.629 93.4242 222.617 92.4361Z",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.406 44.2276C175.394 43.2395 176.996 43.2395 177.984 44.2276L234.188 100.433C235.176 101.422 235.176 103.024 234.188 104.012C233.2 105 231.598 105 230.61 104.012L174.406 47.8058C173.418 46.8177 173.418 45.2157 174.406 44.2276Z",
    fill: "#C4D2E0"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8945,
    y: 122.397,
    width: 69.0072,
    height: 12.1065,
    rx: 6.05326,
    fill: "#A3BBD1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 111.484,
    y: 122.125,
    width: 40.7556,
    height: 12.8089,
    rx: 6.40444,
    fill: "#A3BBD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9712 64.5889C32.7933 64.5889 29.918 67.0253 29.918 70.7935C29.918 73.1996 31.7718 76.0295 35.4718 79.2907C35.7594 79.5404 36.1907 79.5404 36.4782 79.2907C40.1707 76.0295 42.0245 73.1996 42.0245 70.7935C42.0245 67.0253 39.1492 64.5889 35.9712 64.5889ZM35.9712 72.1554C35.1389 72.1554 34.4579 71.4745 34.4579 70.6421C34.4579 69.8098 35.1389 69.1288 35.9712 69.1288C36.8036 69.1288 37.4845 69.8098 37.4845 70.6421C37.4845 71.4745 36.8036 72.1554 35.9712 72.1554Z",
    fill: "#003A70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261.659 93.6436C258.481 93.6436 255.605 96.08 255.605 99.8481C255.605 102.254 257.459 105.084 261.159 108.345C261.447 108.595 261.878 108.595 262.166 108.345C265.858 105.084 267.712 102.254 267.712 99.8481C267.712 96.08 264.837 93.6436 261.659 93.6436ZM261.659 101.21C260.826 101.21 260.145 100.529 260.145 99.6968C260.145 98.8645 260.826 98.1835 261.659 98.1835C262.491 98.1835 263.172 98.8645 263.172 99.6968C263.172 100.529 262.491 101.21 261.659 101.21Z",
    fill: "#003A70"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1215_28531"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.359,
    y: 52.1792,
    width: 95.6415,
    height: 95.6415,
    rx: 6.98667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.a3a902d0736e5719af9f89daa1895908.svg";
export { ForwardRef as ReactComponent };